/*
 * Project: LegalPlace assistant
 * File: src\redux\actions\loading.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */

export const IS_LOADING = 'IS_LOADING';
export const NOT_LOADING = 'NOT_LOADING';

export const WIZARD_LOAD = 'WIZARD_LOADING';
export const WIZARD_UNLOAD = 'WIZARD_UNLOADING';
export const PRICE_LOAD = 'PRICE_LOADING';
export const PRICE_UNLOAD = 'PRICE_UNLOADING';
export const IS_CHECKING = 'IS_CHECKING';
export const IS_CHECKING_PAYMENT = 'IS_CHECKING_PAYMENT';


export function setChecking(val) {
  return {
    type: IS_CHECKING,
    is_checking: val,
  };
}

function setLoadingState(is_loading) {
  if (!is_loading) {
    return {
      type: NOT_LOADING,
    };
  }
  return {
    type: IS_LOADING,
  };
}

export function loadingWizard() {
  return {
    type: WIZARD_LOAD,
  };
}

export function unloadingWizard() {
  return {
    type: WIZARD_UNLOAD,
  };
}

export function loadingPricing() {
  return {
    type: PRICE_LOAD,
  };
}

export function unloadingPricing() {
  return {
    type: PRICE_UNLOAD,
  };
}

export function checkingPayment(is_checking) {
  return {
    type: IS_CHECKING_PAYMENT,
    is_checking,
  };
}


export default setLoadingState;



// WEBPACK FOOTER //
// ./src/redux/actions/loading.js